<template>
   <div>
      <div id="taskDialog">
         <el-dialog title="任务面板" :visible.sync="dialogVisible" top="20px" width="60%" :before-close="taskPanelClose">
            <el-tabs type="border-card">
               <el-tab-pane label="我接收到的任务" id="waitPane">
                  <div v-if="taskReceive.length < 1" style="text-align:center">暂无内容</div>
                  <div v-for="item in taskReceive" :key="item.taskId" @click="goEarlyWarningPage(item.targetPath)">
                     <el-card class="box-card">
                        <div slot="header" id="btnBox" :style="{ backgroundColor: getColor(item.taskLevel) }">
                           <span>{{ item.taskName }}</span>
                           <div>
                              <el-button v-if="item.taskStatus == 0 && item.taskSource != 0" type="success" size="small" @click.stop="updateTask(2, item.taskId, '完成')">完成</el-button>
                              <el-button v-if="item.taskStatus == 0 && item.taskSource == 1" type="warning" size="small" @click="updateTask(3, item.taskId, '拒绝')">拒绝</el-button>
                              <el-button v-if="item.taskStatus == 2 && item.taskSource != 0" type="info" size="small" @click="updateTask(0, item.taskId, '撤回')">撤回</el-button>
                           </div>
                        </div>
                        <div class="tpContentBox">
                           <div>
                              <p>{{ item.taskContent }}</p>
                              <p class="tpContentBoxP2">
                                 <span>{{ item.taskSponsorName }}</span>
                                 <span v-if="item.createTime" class="spanMargin">
                                    {{ $common.getLocalTime(item.createTime, true) }}
                                 </span>
                                 <span>创建({{ item.taskSource == 0 ? '系统' : '自定义' }}任务)</span>
                                 <span class="spanMargin"> 状态:
                                    <span v-if="item.taskStatus == 0" style="color:#f56c6c;">{{
                                                    getTaskStatus(item.taskStatus) }}</span>
                                    <span v-if="item.taskStatus == 2" style="color:#67c23a;">{{
                                                    getTaskStatus(item.taskStatus) }}</span>
                                 </span>
                                 <span v-if="item.finishTime"> 完成时间
                                    {{ $common.getLocalTime(item.finishTime, true) }}
                                 </span>
                              </p>
                           </div>
                        </div>
                     </el-card>
                  </div>
               </el-tab-pane>

               <el-tab-pane label="我创建的任务" id="overPane">
                  <div v-if="taskOwn.length < 1" style="text-align:center">暂无内容</div>
                  <div v-for="item in taskOwn" :key="item.taskId">
                     <el-card class="box-card">
                        <div slot="header" id="btnBox" :style="{ backgroundColor: getColor(item.taskLevel) }">
                           <span>{{ item.taskType }}</span>
                           <el-button v-if="item.taskStatus == 0 && item.taskSource != 0" type="warning" size="small" @click="updateTask(1, item.taskId, '关闭')">关闭</el-button>
                        </div>
                        <div class="tpContentBox">
                           <div>
                              <p>{{ item.taskContent }}</p>
                              <p class="tpContentBoxP2">
                                 <span v-if="item.createTime" class="spanMargin">
                                    {{ $common.getLocalTime(item.createTime, true) }}
                                 </span>
                                 <span>向 {{ item.taskReceiverName }}</span>
                                 <span> 创建({{ item.taskSource == 0 ? '系统' : '自定义' }}任务)</span>
                                 <span class="spanMargin"> 状态:{{ getTaskStatus(item.taskStatus) }}</span>
                                 <span v-if="item.finishTime"> 完成时间
                                    {{ $common.getLocalTime(item.finishTime, true) }}
                                 </span>
                              </p>
                           </div>
                        </div>
                     </el-card>
                  </div>
               </el-tab-pane>
            </el-tabs>

            <span slot="footer" class="dialog-footer">
               <el-button @click="taskPanelClose">取 消</el-button>
            </span>
         </el-dialog>
      </div>

      <div v-if="createDialogVisible" id="createDialog">
         <el-dialog title="创建自定义任务" :visible.sync="createDialogVisible" top="10%" width="60%">
            <el-form label-width="150px" size="mini" ref="createTaskData" :model="createTaskData">
               <el-row>
                  <el-col :span="12">
                     <el-form-item label="任务名称" prop="taskName" :rules="[{ required: true, message: '任务名称不能为空', trigger: ['blur', 'change'] }]">
                        <el-input v-model="createTaskData.taskName"></el-input>
                     </el-form-item>
                  </el-col>
                  <el-col :span="12">
                     <el-form-item label="接收人" prop="taskReceiverName" :rules="[{ required: true, message: '接收人不能为空', trigger: ['blur', 'change'] }]">
                        <el-input @focus="openSearch('4444770562019328')" v-model="createTaskData.taskReceiverName"></el-input>
                     </el-form-item>
                  </el-col>
               </el-row>
               <el-row>
                  <el-col :span="12">
                     <el-form-item label="任务内容">
                        <el-input type="textarea" v-model="createTaskData.taskContent"></el-input>
                     </el-form-item>
                  </el-col>
                  <el-col :span="12">
                     <el-form-item label="任务级别" prop="taskLevel" :rules="[{ required: true, message: '请选择任务级别', trigger: ['blur', 'change'] }]">
                        <!-- 等级 -->
                        <el-select v-model="createTaskData.taskLevel" placeholder="请选择">
                           <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                           </el-option>
                        </el-select>
                     </el-form-item>
                  </el-col>
               </el-row>
               <el-row>
                  <el-col :span="12">
                     <el-form-item label="提醒方式" prop="reminderType" :rules="[{ required: true, message: '请选择提醒方式', trigger: ['blur', 'change'] }]">
                        <el-radio-group v-model="createTaskData.reminderType">
                           <el-radio-button label="0">普通</el-radio-button>
                           <el-radio-button label="1">强提醒</el-radio-button>
                        </el-radio-group>
                     </el-form-item>
                  </el-col>
                  <el-col :span="12">
                     <el-form-item label="备注">
                        <el-input type="textarea" v-model="createTaskData.taskRemark"></el-input>
                     </el-form-item>
                  </el-col>
               </el-row>
            </el-form>
            <div class="footer">
               <el-button @click="cancel" size="">取 消</el-button>
               <el-button type="primary" @click="submit()">确 定 创 建</el-button>
            </div>
         </el-dialog>
      </div>
      <!-- 检索方案 -->
      <el-dialog :title="seTitle" v-if="searchDialogVisible" :visible.sync="searchDialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
   </div>
</template>

<script>
import SearchScheme from '../byComponents/SearchScheme.vue'
export default {
   name: 'TaskPanel',
   props: {
      taskObj: {
         type: Object,
         require: true
      }
   },
   components: {
      SearchScheme
   },
   data() {
      return {
         colorList: ['#00BFDD', '#7874CE', '#FFAB00', '#E64C66'],    //一级，二级，三级，四级
         dialogVisible: false,
         createDialogVisible: false,
         taskReceive: [], //接收
         taskOwn: [], //发送
         options: [{
            value: '1',
            label: '1级'
         }, {
            value: '2',
            label: '2级'
         }, {
            value: '3',
            label: '3级'
         }, {
            value: '4',
            label: '4级'
         }],
         createTaskData: {
            "reminderType": 0,
            "taskContent": "",
            "taskLevel": '1',
            "taskName": "",
            "taskReceiver": '',
            "taskReceiverName": '',
            "taskRemark": ""
         },
         seTitle: "", //检索
         searchDialogVisible: false,
         seWidth: "0",
         seId: 0,
      }
   },
   methods: {
      //去预警页面
      goEarlyWarningPage(e) {
         if (e && e != null && e != '') {
            this.$emit('getTaskParam', e)
         }
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId) {
         this.searchDialogVisible = true;
         this.seId = sId;
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.createTaskData.taskReceiver = val.opmId
            this.createTaskData.taskReceiverName = val.opmName
            this.searchDialogVisible = false;
         } else {
            this.searchDialogVisible = false;
            this.$message({
               message: "检索失败",
               type: "error",
            });
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      //确认创建
      submit() {
         let flag = false;
         let _this = this
         this.$refs['createTaskData'].validate((valid) => {
            if (valid) {
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               flag = true;
               return false;
            }
         });
         if (flag) return false;

         this.$http.desystaskAddTask(this.createTaskData).then((res) => {
            if (res && res.status == 200) {
               if (_this.taskObj.type == 'header') {
                  _this.getTaskPanelList()
               } else if (_this.taskObj.type == 'calendar') {
                  _this.getQueryTaskDataByDate()
               } else if (_this.taskObj.type == 'all') {
                  _this.getMonthAllTask()
               }
               _this.createDialogVisible = false
               _this.init()
            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
               this.createDialogVisible = false
            }
         }).catch((rej) => {
            this.$message({
               message: rej.message,
               type: "error",
            })
            this.createDialogVisible = false
         })
      },
      //取消创建
      cancel() {
         this.$confirm('确定取消创建任务吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.createDialogVisible = false
            this.init()
         }).catch(() => { })
      },
      //点击唤起创建任务弹窗
      createTaskClick() {//desystaskAddTask
         this.createDialogVisible = true
      },
      //修改任务
      updateTask(status, id, desc) {
         let _this = this
         this.$confirm('是否' + desc + '该任务吗？', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
         }).then(() => {
            _this.$http.updateTaskStatus({
               "taskId": id,
               "taskStatus": status
            }).then((res) => {
               if (res && res.status == 200) {
                  if (_this.taskObj.type == 'header') {
                     _this.getTaskPanelList()
                  } else if (_this.taskObj.type == 'calendar') {
                     _this.getQueryTaskDataByDate()
                  } else if (_this.taskObj.type == 'all') {
                     _this.getMonthAllTask()
                  }
               } else {
                  _this.$message({
                     message: res.message,
                     type: "error",
                  })
               }
            }).catch((rej) => {
               _this.$message({
                  message: rej.message,
                  type: "error",
               })
            })
         }).catch(() => { });
      },

      //向父级推送
      taskPanelClose() {
         this.dialogVisible = false
         this.$emit('taskPanelClose', this.dialogVisible)
      },

      //查询近30天所有任务信息
      getMonthAllTask() {
         this.$http.getQueryAllTask().then((res) => {
            if (res && res.status == 200) {
               let data = JSON.parse(JSON.stringify(res.result))
               this.taskReceive = []
               this.taskOwn = []
               data.desysAllotmenttaskReceive.forEach(v => { //接收
                  this.taskReceive.push(v)
               })
               data.desysAllotmenttaskOwn.forEach(v => { //发出
                  this.taskOwn.push(v)
               })
               this.dialogVisible = true
            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         }).catch((rej) => {
            this.$message({
               message: rej.message,
               type: "error",
            })
         })
      },

      //获取头部任务面板数据
      getTaskPanelList() { //header
         this.$http.getQueryTaskByType({ "ids": [this.taskObj.taskType] }).then((res) => {
            if (res && res.status == 200) {
               let data = JSON.parse(JSON.stringify(res.result))
               this.taskReceive = []
               this.taskOwn = []
               data.desysAllotmenttaskReceive.forEach(v => { //接收
                  this.taskReceive.push(v)
               })
               data.desysAllotmenttaskOwn.forEach(v => { //发出
                  this.taskOwn.push(v)
               })
               this.dialogVisible = true
            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         }).catch((rej) => {
            this.$message({
               message: rej.message,
               type: "error",
            })
         })
      },

      //获取指定时间任务面板数据
      getQueryTaskDataByDate() { //calendar
         this.$http.getQueryTaskDataByDate({ "queryDate": this.taskObj.dayTime }).then((res) => {
            if (res && res.status == 200) {
               let data = JSON.parse(JSON.stringify(res.result))
               this.taskReceive = []
               this.taskOwn = []
               data.desysAllotmenttaskReceive.forEach(v => { //接收
                  this.taskReceive.push(v)
               })
               data.desysAllotmenttaskOwn.forEach(v => { //发出
                  this.taskOwn.push(v)
               })
               this.dialogVisible = true
            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         }).catch((rej) => {
            this.$message({
               message: rej.message,
               type: "error",
            })
         })
      },

      //获取颜色
      getColor(str) {
         str = str.toString()
         if (str == 1 || str == '一' || str.indexOf('1') > 0 || str.indexOf('一') > 0) {
            return this.colorList[0]
         } else if (str == 2 || str == '二' || str.indexOf('2') > 0 || str.indexOf('二') > 0) {
            return this.colorList[1]
         } else if (str == 3 || str == '三' || str.indexOf('3') > 0 || str.indexOf('三') > 0) {
            return this.colorList[2]
         } else {
            return this.colorList[3]
         }
      },
      //获取状态0.初始1.关闭（发起人）2.完成3.拒绝（接收人）
      getTaskStatus(num) {
         if (num == 0) {
            return '初始'
         } else if (num == 1) {
            return '关闭'
         } else if (num == 2) {
            return '完成'
         } else {
            return '拒绝'
         }
      },
      //初始化
      init() {
         for (const key in this.createTaskData) {
            this.createTaskData[key] = ''
         }
         this.createTaskData.reminderType = 0
         this.createTaskData.taskLevel = '1'
         this.$refs['createTaskData'].resetFields();
      },

   },
   created() {
      if (this.taskObj.type == 'header') {
         this.getTaskPanelList()
      } else if (this.taskObj.type == 'calendar') {
         this.getQueryTaskDataByDate()
      } else if (this.taskObj.type == 'all') {
         this.getMonthAllTask()
      }
   },
}
</script>

<style scoped>
::v-deep #taskDialog .el-dialog {
   height: 96%;
   overflow: auto;
   margin-bottom: 0;
}

::v-deep #taskDialog .el-dialog__body {
   height: 86%;
   overflow: hidden;
}

#createDialog ::v-deep .el-dialog {
   height: 50%;
}

#createDialog ::v-deep .el-form {
   margin-top: 20px;
   margin-bottom: 40px;
}

.el-tabs {
   height: 95%;
}

::v-deep .el-tabs__nav-wrap {
   margin-bottom: 0;
}

::v-deep .el-tabs__nav {
   width: 100%;
}

::v-deep .el-tabs__item {
   width: 50%;
   font-size: 20px;
   text-align: center;
}

::v-deep .el-tabs--border-card > .el-tabs__content {
   height: 94%;
   overflow: auto;
}

::v-deep .el-tabs__content::-webkit-scrollbar {
   display: none;
   /* Chrome Safari */
}

::v-deep .el-tabs__content,
::v-deep #taskDialog .el-dialog {
   /* 隐藏滚动条 */
   scrollbar-width: none;
   /* firefox */
   -ms-overflow-style: none;
   /* IE 10+ */
}

/* ::v-deep .el-card {
    margin-bottom: 20px;
} */

::v-deep .el-card:last-child {
   margin-bottom: 8px;
}

::v-deep .el-card__header {
   padding: 0;
}

#btnBox {
   padding: 8px 20px;
   color: #fff;
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-items: baseline;
}

.tpContentBox {
   display: flex;
   flex-direction: column;
   justify-content: space-between;
}

.tpContentBox .tpContentBoxP2 {
   margin-top: 20px;
   font-size: 14px;
   color: #999;
}

.tpContentBox .tpContentBoxP2 .spanMargin {
   margin: 0 2px;
}

.footer {
   margin-top: 20px;
   display: flex;
   justify-content: center;
   align-items: center;
}
</style>
